import { db } from 'cf-core/src/config/firebase'

export function fetchUser(uid) {
  return db.collection('Users').doc(uid).get()
}
